import { useCallback } from 'react';
import gettext from '@sdk/lang/gettext';
import ConfirmModal from '@sdk/components/ui/confirmModal/ConfirmModal';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

import ExclamationMarkIcon from '@web/assets/svg/UI/exclamation-mark.svg';
import { useDeleteAnnouncement } from '@web/announcements/hooks/useDeleteAnnouncement';

import { Description, IconWrapper } from './deleteAnnouncementConfirm.styles';

type Props = {
  id: number;
  onClose: () => void;
  onDelete: () => void;
};

export const DeleteAnnouncementConfirm = ({ id, onClose, onDelete }: Props) => {
  const { mutateAsync } = useDeleteAnnouncement();

  const handleAction = useCallback(() => {
    onDelete();

    return mutateAsync(id);
  }, [id, onDelete, mutateAsync]);

  return (
    <ConfirmModal
      buttonsPadding={0}
      dismissOnBackdropClick={false}
      fullScreen
      titleText={gettext('Please confirm')}
      titleThemeColor={ThemeColorType.danger}
      titleIcon={
        <IconWrapper>
          <ExclamationMarkIcon aria-hidden={true} />
        </IconWrapper>
      }
      primaryButtonText={gettext('Delete')}
      primaryButtonType={ButtonType.danger}
      dismiss={onClose}
      onPrimaryClick={handleAction}
      zIndex={1045}>
      <Description>{gettext('Are you sure you want to delete this announcement?')}</Description>
    </ConfirmModal>
  );
};
